import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { ContentTrackStepDetail } from '@src/components/sco/Education/ContentTrackStepDetail';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { EducationPage } from '@src/templates/EducationPage';
import { useParams } from 'next/navigation';
import React, { useEffect } from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default EducationPage(function Page(props) {
  const layout = useParentAppLayout();
  const educationContext = useEducationContext();
  const routeParams = useParams();
  useEffect(() => {
    layout.updatePanel('edu-aside', {
      isPanelOpen: false
      // isDrawerOpen: false,
    });
    educationContext.setActiveSection('courses.track.section.step');
  }, []);
  return <ContentTrackStepDetail contentTrackSectionSlug={`${routeParams?.contentTrackSectionSlug}`} contentTrackSlug={`${routeParams?.contentTrackSlug}`} contentTrackStepSlug={`${routeParams?.contentTrackStepSlug}`} />;
});